module.exports = __webpack_public_path__ + "img/branding-logo-huisstijl-full-on-eventsector-thumbnail.92844f5d.png";